import { createFocusTrap } from 'focus-trap';

const toggleSearch = document.querySelector('#toggle-search > a');
const togglePrimaryMenu = document.querySelector(
  '.wp-custom-block-navigation-primary .wp-block-navigation__responsive-container-open'
);
const toggleOffCanvasWrapper = document.querySelector(
  '#toggle-menu-secondary > a'
);
const toggleSubMenu = document.querySelectorAll(
  '.wp-block-navigation-submenu__toggle'
);

const elSearch = document.querySelector('.wp-block-search');
const elPrimaryMenu = document.querySelector(
  '.wp-custom-block-navigation-primary .wp-block-navigation__responsive-container'
);
const elOffCanvasWrapper = document.querySelector('#offcanvas-wrapper');
const elSecondaryMenu = document.querySelector(
  '.wp-custom-block-column-offcanvas'
);

const searchFocusTrap = createFocusTrap(elSearch, {
  clickOutsideDeactivates: true,
  onDeactivate: () => {
    elSearch.classList.remove('is-open');
    toggleSearch.classList.remove('is-open');
  },
});

const openSearch = () => {
  elSearch.classList.add('is-open');
  toggleSearch.classList.add('is-open');
  searchFocusTrap.activate();
};

toggleSearch.setAttribute('role', 'button');
toggleSearch.setAttribute('tabindex', '0');

toggleSearch.addEventListener('click', openSearch);
toggleSearch.addEventListener('keydown', (e) => {
  if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
    openSearch();
  }
});

// Primary navigation panel
const openPrimaryMenu = () => {
  elPrimaryMenu.classList.add('is-menu-open');
  togglePrimaryMenu.setAttribute('aria-expanded', 'true');
  primaryMenuFocusTrap.activate();
};

const primaryMenuFocusTrap = createFocusTrap(elPrimaryMenu, {
  clickOutsideDeactivates: true,
  onDeactivate: () => {
    elPrimaryMenu.classList.remove('is-menu-open');
    togglePrimaryMenu.setAttribute('aria-expanded', 'false');
  },
});

togglePrimaryMenu.addEventListener('click', openPrimaryMenu);

// Secondary navigation panel
const openOffcanvasWrapper = () => {
  elOffCanvasWrapper.classList.add('is-open');
  toggleOffCanvasWrapper.classList.add('is-open');
  secondaryNavFocusTrap.activate();
};

toggleOffCanvasWrapper.setAttribute('role', 'button');
toggleOffCanvasWrapper.setAttribute('tabindex', '0');

toggleOffCanvasWrapper.addEventListener('click', openOffcanvasWrapper);
toggleOffCanvasWrapper.addEventListener('keydown', (e) => {
  if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
    openOffcanvasWrapper();
  }
});

const secondaryNavFocusTrap = createFocusTrap(elSecondaryMenu, {
  clickOutsideDeactivates: true,
  onDeactivate: () => {
    elOffCanvasWrapper.classList.remove('is-open');
    toggleOffCanvasWrapper.classList.remove('is-open');
  },
});

[...toggleSubMenu].forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    const isExpanded =
      e.currentTarget.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isExpanded);

    [...toggleSubMenu]
      .filter((el) => el !== toggle)
      .forEach((el) => el.setAttribute('aria-expanded', 'false'));
  });
});
